if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.bar = this.querySelector('.suroor-sticky-cart__bar');

        this.isStuck = false;
        this.hiddenByFooter = false;

        this.addEventListener('click', this.handleClick.bind(this));
        this.setupObservers();
      }

      disconnectedCallback() {
        this.buyButtonsObserver?.disconnect();
        this.footerObserver?.disconnect();
      }

      setupObservers() {
        const submitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!submitButton) return;
        const target = submitButton.closest('.product-form__buttons') || submitButton;

        const footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');

        this.buyButtonsObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;
          if (!entry.isIntersecting && !this.isStuck) {
            this.isStuck = true;
            this.show();
          } else if (entry.isIntersecting && this.isStuck) {
            this.isStuck = false;
            this.hiddenByFooter = false;
            this.hide();
          }
        });
        this.buyButtonsObserver.observe(target);

        if (footer) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (!entry) return;
              if (entry.isIntersecting && this.isStuck) {
                this.hiddenByFooter = true;
                this.hide();
              } else if (!entry.isIntersecting && this.hiddenByFooter) {
                const rect = target.getBoundingClientRect();
                if (rect.bottom < 0) {
                  this.hiddenByFooter = false;
                  this.show();
                }
              }
            },
            { rootMargin: '200px 0px 0px 0px' }
          );
          this.footerObserver.observe(footer);
        }
      }

      show() {
        if (this.bar) this.bar.dataset.stuck = 'true';
      }

      hide() {
        if (this.bar) this.bar.dataset.stuck = 'false';
      }

      handleClick(event) {
        if (!event.target.closest('.suroor-sticky-cart__button')) return;
        const submitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (submitButton && !submitButton.disabled && submitButton.getAttribute('aria-disabled') !== 'true') {
          submitButton.click();
        }
      }
    }
  );
}
